import { Channel } from 'ops/common/models/channel';

export interface ExhaustGraphChannel {
    channel: Channel;
    title: string;
    value: number;
}

export interface DeviationGraphChannel {
    channel: Channel;
    title: string;
    value: number;
    temperatureChannel: Channel;
}

export interface BarGraphChannel {
    channel: Channel;
    title: string;
    value: number;
}

export interface GraphStyleType {
    blueColor: string;
    whiteColor: string;
    fontSize: number;
    maxSize: number;
    hoverBgColor: string;
    hoverColor: string;
    yAxisColor: string;
    tooltipBgColor: string;
    tooltipBorderColor: string;
    alarmNormal: string;
    alarmWarning: string;
    alarmCaution: string;
    alarm: string;
    alarmDefault: string;
    alarmNormalHover: string;
    alarmWarningHover: string;
    alarmCautionHover: string;
    alarmHover: string;
    alarmDefaultHover: string;
    gaugeDefault: string;
}

export const DefaultGraphStyle: GraphStyleType = {
    blueColor: '#9cb2fb',
    whiteColor: '#fff',
    fontSize: 14,
    maxSize: 600,
    hoverBgColor: 'rgba(156, 178, 251, 0.3)',
    hoverColor: '#c6d3ff',
    yAxisColor: '#42566d',
    tooltipBgColor: '#2c3a48',
    tooltipBorderColor: '#42566d',
    alarmNormal: '#20e420',
    alarmWarning: '#f69400',
    alarmCaution: '#fad900',
    alarm: '#e41b1b',
    alarmDefault: '#9cb2fb',
    alarmNormalHover: '#45d562',
    alarmWarningHover: '#db9d4b',
    alarmCautionHover: '#dece4b',
    alarmHover: '#cf485e',
    alarmDefaultHover: '#c6d3ff',
    gaugeDefault: '#4E5E7E',
};

export const gaugeMaxDivisions = 11;
export const gaugeMinDivisions = 1;
